import React from 'react';
import { useTranslation } from 'react-i18next';

// MUI Icons
import MapOutlinedIcon from '@mui/icons-material/MapOutlined';

// Custom Components
import TableButton from './TableButton';

// Types
import { ITableActionButtonDetail } from '@/@types/ui/Table';

function TableButtonGeneratePdf(props: ITableActionButtonDetail) {
  const { t } = useTranslation();

  return (
    <TableButton allow="one" startIcon={<MapOutlinedIcon />} selection={[]} {...props}>
      {t('buttons.download_pdf')}
    </TableButton>
  );
}

export default TableButtonGeneratePdf;
